import React from 'react'
import { useTranslation, withI18nContext } from '@mc/i18n'
import { TableFeature, useTiersInfo } from '@mc/plans-ui'
import { i18nInstance } from '../../../i18n/i18nInstance'
import { PROMO_I18N_NAMESPACE } from '../../../lib/constants'
import { PricingCell } from './PricingCell'

const PricingFeatureComp = () => {
  const { t } = useTranslation(PROMO_I18N_NAMESPACE)
  const { individual, duo, family } = useTiersInfo()

  return (
    <TableFeature.Feature>
      <TableFeature.Label title={t('common.plans.features.pricing.title')} />
      <TableFeature.Individual>
        <PricingCell tier={individual} />
      </TableFeature.Individual>
      <TableFeature.Duo>
        <PricingCell tier={duo} />
      </TableFeature.Duo>
      <TableFeature.Family>
        <PricingCell tier={family} />
      </TableFeature.Family>
    </TableFeature.Feature>
  )
}

export const PricingFeature = withI18nContext(i18nInstance)(PricingFeatureComp)
